import { ProfileContactsWidgetButtonSelect } from '../ProfileContactsWidgetButtonSelect'

import * as styles from './ProfileContactsWidgetEmpty.module.css'

function ProfileContactsWidgetEmpty({
  addTypes,
  canEdit,
  existingTypes,
  onSelectItem,
}) {
  return canEdit ? (
    <ProfileContactsWidgetButtonSelect
      addTypes={addTypes}
      className={styles.buttonEmpty}
      existingTypes={existingTypes}
      onSelectItem={onSelectItem}
    />
  ) : null
}

export default ProfileContactsWidgetEmpty
